<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import '@/styles/libs/tachyons.scss';
import { trackEvent, getStorage, setStorage } from '@/utils/common';

export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.$store.state.siteDetails.site_name,
      link: [
        {
          rel: 'shortcut icon',
          type: 'image/png',
          href: this.favicon
        }
      ]
    };
  },
  computed: {
    favicon() {
      if (this.$store.state.siteDetails.helpcenter_type === 'csweepshc' ||
              this.$store.state.siteDetails.helpcenter_type === 'lsweepshc') {
        return `https://www.${this.$store.state.siteDetails.domain_name}/${this.$store.state.siteDetails.site_name.toLowerCase().replace(' ', '')}/favicon.ico`;
      }
      if (this.$store.state.siteDetails.domain_name === 'meedyaa.com') {
        return 'https://cdn.milkbox.com/brands/width=32,height=32,fit=contain/2968ea06-3784-4266-9737-51a4df5eaf03/icon.png';
      }
      if (this.$store.state.siteDetails.domain_name === 'clickplay.io') {
        return 'https://cdn.milkbox.com/brands/width=32,height=32,fit=contain/b830f8b7-1a23-469a-9ddc-496c8a86063b/icon.png';
      }
      if (this.$store.state.siteDetails.domain_name === 'plustrustedvpn.com') {
        return 'https://cdn.milkbox.com/brands/width=32,height=32,fit=contain/e6d73413-f0a1-4743-91cb-4f6d8f74c5e6/icon.png';
      }
      return this.$store.state.siteDetails.icon_url || this.$store.state.siteDetails.logo_url;
    }
  },
  methods: {
    trackUniqueVisit() {
      if (!getStorage('zendesk_unique_visit')) {
        trackEvent('zendesk_unique_visit', function() {
          setStorage('zendesk_unique_visit', true);
        });
      }
    }
  },
  created() {
    this.trackUniqueVisit();
    this.$store.dispatch('attachI18n', this.$parent._i18n);
    this.$store.dispatch('fetchArticles');
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Lato|Roboto:300,400,500,700,900');
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap');

@import '@/styles/variables.scss';

.file-upload .title > span > span {
  color: $theme-highlight;
}
.file-upload-zeus .title > span > span {
  color: #287EFF;
}
.file-upload-vpn .title > span > span {
  color: #3E3EFF;
}

@import '@/styles/stylesheet.scss';

// Router View Animation
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

// General Layout.
////////////////////////////////////////

body,
html {
  background-color: #f7f4f4;
  font-size: 15px;
  line-height: 1.5;
  margin: 0;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  color: #676767;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// Typography / buttons
////////////////////////////////////////
.text--theme-highlight {
  color: $theme-highlight;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
  font-weight: 400;
  margin-top: 0;
}

// for html that is inserted to the page by some other methos than the view template we will lose scoping
// so the solution is to attach data properties to these elements so we know what we want to target
.article-body div[data-external],
div[data-external] {
  ul {
    list-style-type: disc;
  }
  a {
    color: #3bb4ef;
    text-decoration: none;
  }
}
.article-body.article-body-zeus div[data-external],
div[data-external].article-body.article-body-zeus{
  a {
    color: #287EFF;
    text-decoration: none;
    font-weight: 600;
  }
}

.article-body.article-body_vpn div[data-external],
div[data-external].article-body.article-body_vpn{
  a {
    color: #3E3EFF;
    text-decoration: none;
    font-weight: 600;
  }
}
.page_wrap_contact  .article-body div[data-external] a, div[data-external] a {
  color: #3E3EFF;
}

.btn--text {
  padding: 0;
  -webkit-appearance: none;
  font-weight: 600;
  border: 0;
}

.link {
  color: #333;
}

.footer-text a.link {
  color: #3bb4ef;
  text-decoration: underline;
}
.footer-text a.link:hover {
  opacity: 0.8;
}
.footer-text-zeus a.link {
  color: #000;
  text-decoration: none;
  opacity: 1;
}
.footer-text-zeus a.link:hover {
  text-decoration: underline;
}
.footer-text-vpn a.link {
  color: #fff;
  text-decoration: none;
  font-weight: 600;
}
.footer-text-vpn a.link:hover {
  opacity: 0.9;
}
.lb {
  color: #99d8f7;
}

.input {
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
.row-container {
  max-width: 80em;
  margin: 0 auto;
}

.row-container--l {
  max-width: 100em;
}

.category-view {
  margin-bottom: 32px;
}

// Content Area, and columns of main pages.
////////////////////////////////////////
.content {
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
}
.content__aside {
  .sidebar__links {
    display: none;
  }
}
.content__main {
  padding: 0 1rem;
}

@media (min-width: 599px) {
  .content {
    flex-direction: row;
  }
  .content__aside {
    width: 25%;
    padding-right: 2rem;

    .sidebar__links {
      display: block;
    }
  }
  .content__main {
    width: 75%;
    padding-left: 0;
    margin-top: -5px; // sorry (sad face)
  }
}
</style>
